// extracted by mini-css-extract-plugin
export default {"root":"Suggestion-root_CmnVH"};